import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import { toggleSignalFlag } from '../../../../actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'mainId', null)

    return {
        toggledFlags: state.getIn([
            'ui',
            'workspace',
            'report',
            id,
            'blocks',
            'syntheticIndicators',
            'customData',
            'toggledFlags',
        ]),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, { toggleSignalFlag })
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
